module.exports = __webpack_public_path__ + "static/img/DarrenLehmann.6b61810.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DarrenLehmann.jpg
// module id = 0cuV
// module chunks = 0